import React from 'react'

const Box = (props) => {
    return (
        <>
               <div className="col-md-4">
            <div className="box mt-5 box-hover p-3 rounded project">
            {props.font}
            <h4>{props.head}</h4>
            </div>
            </div>
        </>
    )
}

export default Box
